/** The pool: every Pokémon in the draft, its points, and who has it */
import { getOwner, getPoints } from '@ogreclan/league-core';
import { useMemo, useState } from 'preact/hooks';
import type { LeagueProps } from '../pages/league';
import { Mon, nameOf, speciesOf, Types } from '../pokemon';

export function PoolTab({ view, data }: LeagueProps) {
	const { league } = view;
	const points = league.settings.type === 'points';
	const [search, setSearch] = useState('');
	const [show, setShow] = useState<'all' | 'available' | 'taken'>('all');
	const [sort, setSort] = useState<'points' | 'name'>(points ? 'points' : 'name');
	const rows = useMemo(() => Object.keys(league.pool).map(id => ({
		id, name: nameOf(data, id), points: getPoints(league, id), owner: getOwner(league, id), types: speciesOf(data, id)?.types || [],
	})), [league, data]);
	const query = search.trim().toLowerCase();
	const shown = rows
		.filter(row => show === 'all' || (show === 'available') === !row.owner)
		.filter(row => !query || row.name.toLowerCase().includes(query) || row.types.some(type => type.toLowerCase() === query) ||
			row.owner?.name.toLowerCase().includes(query))
		.sort((a, b) => sort === 'points' ? b.points - a.points || a.name.localeCompare(b.name) : a.name.localeCompare(b.name));
	const taken = rows.filter(row => row.owner).length;

	return <div class="card">
		<div class="row" style="margin-bottom:10px">
			<input type="search" placeholder="Search by name, type or player" value={search}
				onInput={e => setSearch((e.target as HTMLInputElement).value)} style="flex:1;min-width:200px" />
			<select value={show} onChange={e => setShow((e.target as HTMLSelectElement).value as typeof show)}>
				<option value="all">All {rows.length}</option>
				<option value="available">Available ({rows.length - taken})</option>
				<option value="taken">Drafted ({taken})</option>
			</select>
			{points && <select value={sort} onChange={e => setSort((e.target as HTMLSelectElement).value as typeof sort)}>
				<option value="points">Most points first</option>
				<option value="name">By name</option>
			</select>}
		</div>
		<div class="table-wrap"><table>
			<thead><tr><th>Pokémon</th><th>Types</th>{points && <th class="num">Points</th>}<th>Drafted by</th></tr></thead>
			<tbody>{shown.map(row => <tr key={row.id} class={row.owner?.id === view.you ? 'you' : ''}>
				<td><Mon data={data} id={row.id} /></td>
				<td><Types types={row.types} /></td>
				{points && <td class="num">{row.points}</td>}
				<td>{row.owner ? row.owner.name : <span class="muted">Available</span>}</td>
			</tr>)}</tbody>
		</table></div>
		{!shown.length && <p class="empty">{rows.length ? 'Nothing matches.' : 'The pool is empty so far.'}</p>}
	</div>;
}
